import FaqPageContainer from '@/app/components/FaqPageComponents/FaqPageContainer';
import { PRIVACY_DATA } from '@/app/pages/PrivacyPolicyPage/privacy';
import { Accordion } from '@/app/shared/ui/Accordion';

const PrivacyPolicyPage = () => {
  return <FaqPageContainer centerContent={<Accordion items={PRIVACY_DATA} />} heading='Privacy Policy' />;
};

export default PrivacyPolicyPage;
